import React, { useEffect, useState, useMemo } from "react";
import {
  Card,
  CardBody,
  Col,
  CardHeader,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import * as moment from "moment";
import TableContainer from "../../Components/Common/TableContainer";
//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getImports as onGetImports } from "../../slices/thunks";
import "react-toastify/dist/ReactToastify.css";

import { createSelector } from "reselect";
import Loader from "../../Components/Common/Loader";

const ShowImports = ({ batchId, open, onClose }) => {
  const [modal, setModal] = useState(open);
  const [rowData, setRowData] = useState(null);

  const dispatch = useDispatch();

  const selectFilesData = createSelector(
    (state) => state.Analysis,
    (imports) => imports,    
    (loading) => loading
  );
  const { imports,loading } = useSelector(selectFilesData);

  const getImports = () => {
    const data = {
      bai_id: batchId,
    };
    dispatch(onGetImports(data));
  };

  useEffect(() => {
    setRowData(imports);
  }, [imports]);

  useEffect(() => {
    setModal(open);
    if (open) {
      getImports();
    }
  }, [open]);

  const toggle = () => {
    if (modal) {
      onClose();
      //setFileList(null);
    } else {
      //setModal(true);
      //setDate(defaultdate());
    }
  };

  const columns = useMemo(
    () => [
      {
        header: "Sales Channel",
        accessorKey: "imp_salesChannel",
        enableColumnFilter: false,
      },
      {
        header: "ASIN",
        accessorKey: "imp_ASIN",
        enableColumnFilter: false,
      },
      {
        header: "Product ID",
        accessorKey: "imp_productID",
        enableColumnFilter: false,
      },
      {
        header: "UPC",
        accessorKey: "imp_UPC",
        enableColumnFilter: false,
      },
      {
        header: "Title",
        accessorKey: "imp_title",
        enableColumnFilter: false,
      },
      {
        header: "Pack Quantity",
        accessorKey: "imp_packQuantity",
        enableColumnFilter: false,
      },
      {
        header: "Custom Notes",
        accessorKey: "imp_customNotes",
        enableColumnFilter: false,
      },
      {
        header: "Last Run",
        accessorKey: "imp_lastRun",
        enableColumnFilter: false,

        Cell: ({ cell }) => (
          <>
            {moment(cell.getValue()).format("MM/DD/YYYY")}
            <br />
            <small className="text-muted">
              {moment(cell.getValue()).format("hh:mm A")}
            </small>
          </>
        ),
      },
      {
        header: "Brand",
        accessorKey: "imp_brand",
        enableColumnFilter: false,
      },
      {
        header: "Brand Restriction",
        accessorKey: "imp_brandRestriction",
        enableColumnFilter: false,
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
      },
      {
        header: "Amazon Link",
        accessorKey: "imp_amazonLink",
        enableColumnFilter: false,
        Cell: ({ cell }) => (
          <a href={cell.getValue()} target="_blank" rel="noopener noreferrer">
            Link
          </a>
        ),
      },
      {
        header: "New FBA Offers",
        accessorKey: "imp_newFBAOffers",
        enableColumnFilter: false,
      },
      {
        header: "New FBM Offers",
        accessorKey: "imp_newFBMOffers",
        enableColumnFilter: false,
      },
      {
        header: "Is Hazmat",
        accessorKey: "imp_isHazmat",
        enableColumnFilter: false,
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
      },
      {
        header: "Package Dimensions",
        accessorKey: "imp_packageDimensions",
        enableColumnFilter: false,
      },
      {
        header: "Package Weight",
        accessorKey: "imp_packageWeight",
        enableColumnFilter: false,
      },
      {
        header: "Keepa Link",
        accessorKey: "imp_keepaLink",
        enableColumnFilter: false,
        Cell: ({ cell }) => (
          <a href={cell.getValue()} target="_blank" rel="noopener noreferrer">
            Link
          </a>
        ),
      },
      {
        header: "Estimated Sales",
        accessorKey: "imp_estimatedSales",
        enableColumnFilter: false,
      },
      {
        header: "Variants",
        accessorKey: "imp_variants",
        enableColumnFilter: false,
      },
      {
        header: "Product Rating",
        accessorKey: "imp_productRating",
        enableColumnFilter: false,
      },
      {
        header: "Amazon Seller",
        accessorKey: "imp_amazonSeller",
        enableColumnFilter: false,
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
      },
      {
        header: "90 Days Avg Price",
        accessorKey: "imp_90DaysAvgPrice",
        enableColumnFilter: false,
      },
      {
        header: "Vendor Cost",
        accessorKey: "imp_vendorCost",
        enableColumnFilter: false,
      },
      {
        header: "Sell Price",
        accessorKey: "imp_sellPrice",
        enableColumnFilter: false,
      },
      {
        header: "Referral Fee",
        accessorKey: "imp_referralFee",
        enableColumnFilter: false,
      },
      {
        header: "Inbound Plac",
        accessorKey: "imp_InboundPlac",
        enableColumnFilter: false,
      },
      {
        header: "Fulfillment Subtotal",
        accessorKey: "imp_fulfillmentSubtotal",
        enableColumnFilter: false,
      },
      {
        header: "Pack Cost",
        accessorKey: "imp_packCost",
        enableColumnFilter: false,
      },
      {
        header: "Profit",
        accessorKey: "imp_profit",
        enableColumnFilter: false,
      },
      {
        header: "Margin",
        accessorKey: "imp_margin",
        enableColumnFilter: false,
      },
      {
        header: "ROI",
        accessorKey: "imp_ROI",
        enableColumnFilter: false,
      },
      {
        header: "Stripe Surcharge",
        accessorKey: "imp_stripeSurcharge",
        enableColumnFilter: false,
      },
      {
        header: "Ship To Warehouse",
        accessorKey: "imp_shipToWarehouse",
        enableColumnFilter: false,
      },
      {
        header: "Ship To Amazon",
        accessorKey: "imp_shipToAmazon",
        enableColumnFilter: false,
      },
      {
        header: "Ship To Customer",
        accessorKey: "imp_shipToCustomer",
        enableColumnFilter: false,
      },
      {
        header: "FBA/FBM Prep",
        accessorKey: "imp_FBAFBMPrep",
        enableColumnFilter: false,
      },
      {
        header: "Net Profit",
        accessorKey: "imp_netProfit",
        enableColumnFilter: false,
      },
      {
        header: "Net Profit Margin",
        accessorKey: "imp_netProfitMargin",
        enableColumnFilter: false,
      },
      {
        header: "Previously listed",
        accessorKey: "imp_currentlyInBC",
        enableColumnFilter: false,
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
      },
      {
        header: "New Estimated Sales",
        accessorKey: "imp_newEstimatedSales",
        enableColumnFilter: false,
      },
      {
        header: "Approval To List Code",
        accessorKey: "imp_approvalToListCode",
        enableColumnFilter: false,
      },
      {
        header: "AT Keepa",
        accessorKey: "imp_ATKeepa",
        enableColumnFilter: false,
      },
      {
        header: "Amazon Sells",
        accessorKey: "imp_amazonSells",
        enableColumnFilter: false,
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
      },
      {
        header: "90 Days Avg Buy Box",
        accessorKey: "imp_90DaysAvgBuyBox",
        enableColumnFilter: false,
      },
      {
        header: "AT Sell Price",
        accessorKey: "imp_ATSellPrice",
        enableColumnFilter: false,
      },
      {
        header: "Current Prime Sell Price",
        accessorKey: "imp_currentPrimeSellPrice",
        enableColumnFilter: false,
      },
      {
        header: "Selling Price Variation",
        accessorKey: "imp_sellingPriceVariation",
        enableColumnFilter: false,
      },
      {
        header: "Current eBay Sell Price",
        accessorKey: "imp_currentEbaySellPrice",
        enableColumnFilter: false,
      },
      {
        header: "MAP",
        accessorKey: "imp_MAP",
        enableColumnFilter: false,
      },
      {
        header: "Notes",
        accessorKey: "imp_notes",
        enableColumnFilter: false,
      },
      {
        header: "Stock Notes",
        accessorKey: "imp_stockNotes",
        enableColumnFilter: false,
      },
      {
        header: "Order Notes",
        accessorKey: "imp_orderNotes",
        enableColumnFilter: false,
      },
      {
        header: "Vendor ID",
        accessorKey: "imp_ven_id",
        enableColumnFilter: false,
      },
      {
        header: "Vendor Name",
        accessorKey: "imp_ven_name",
        enableColumnFilter: false,
      },
      {
        header: "Case Quantity",
        accessorKey: "imp_caseQuantity",
        enableColumnFilter: false,
      },
      {
        header: "Confirmed Stock",
        accessorKey: "imp_confirmedStock",
        enableColumnFilter: false,
      },
      {
        header: "MOV",
        accessorKey: "imp_MOV",
        enableColumnFilter: false,
      },
      {
        header: "MOQ",
        accessorKey: "imp_MOQ",
        enableColumnFilter: false,
      },
      {
        header: "Lead Time",
        accessorKey: "imp_leadTime",
        enableColumnFilter: false,
      },
      {
        header: "Final Pack Cost",
        accessorKey: "imp_finalPackCost",
        enableColumnFilter: false,
      },
      {
        header: "Final Pack Cost Check",
        accessorKey: "imp_finalPackCostCheck",
        enableColumnFilter: false,
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
      },
      {
        header: "Shipping Final",
        accessorKey: "imp_shippingFinal",
        enableColumnFilter: false,
      },
      {
        header: "FBA",
        accessorKey: "imp_FBA",
        enableColumnFilter: false,
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
      },
      {
        header: "FBM",
        accessorKey: "imp_FBM",
        enableColumnFilter: false,
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
      },
      {
        header: "eBay",
        accessorKey: "imp_ebay",
        enableColumnFilter: false,
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
      },
      {
        header: "Meltables",
        accessorKey: "imp_meltables",
        enableColumnFilter: false,
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
      },
      {
        header: "Brand Restricted",
        accessorKey: "imp_brandRestricted",
        enableColumnFilter: false,
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
      },
      {
        header: "ASIN Do Not List",
        accessorKey: "imp_ASINDoNotList",
        enableColumnFilter: false,
        Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
      },
      {
        header: "Status",
        accessorKey: "imp_status",
        enableColumnFilter: false,
      },
      {
        header: "Rejection Reason",
        accessorKey: "imp_rejectionReason",
        enableColumnFilter: false,
      },
      {
        header: "Max PWSBP4MS",
        accessorKey: "imp_maxPWSBP4MS",
        enableColumnFilter: false,
      },
      {
        header: "Max UWSBP4MS",
        accessorKey: "imp_maxUWSBP4MS",
        enableColumnFilter: false,
      },
      {
        header: "How Many We Buy",
        accessorKey: "imp_howManyWeBuy",
        enableColumnFilter: false,
      },
      {
        header: "Max MTSO",
        accessorKey: "imp_maxMTSO",
        enableColumnFilter: false,
      },
      {
        header: "Velocity Limiter",
        accessorKey: "imp_velocityLimiter",
        enableColumnFilter: false,
      },
      {
        header: "Num Existing Sellers",
        accessorKey: "imp_numExistingSellers",
        enableColumnFilter: false,
      },
      {
        header: "Total NOASTS2",
        accessorKey: "imp_totalNOASTS2",
        enableColumnFilter: false,
      },
      {
        header: "Num ONBCM",
        accessorKey: "imp_numONBCM",
        enableColumnFilter: false,
      },
      {
        header: "Num OPPM",
        accessorKey: "imp_numOPPM",
        enableColumnFilter: false,
      },
      {
        header: "Num PPM",
        accessorKey: "imp_numPPM",
        enableColumnFilter: false,
      },
      {
        header: "Per MPP",
        accessorKey: "imp_perMPP",
        enableColumnFilter: false,
      },
      {
        header: "PPWBT",
        accessorKey: "imp_PPWBT",
        enableColumnFilter: false,
      },
      {
        header: "Total Order Value",
        accessorKey: "imp_totalOrderValue",
        enableColumnFilter: false,
      },
      {
        header: "Units Per Pack",
        accessorKey: "imp_unitsPerPack",
        enableColumnFilter: false,
      },
      {
        header: "PMOW",
        accessorKey: "imp_PMOW",
        enableColumnFilter: false,
      },
    ],
    []
  );

  return (
    <Modal Modal isOpen={modal} centered fullscreen>
      <ModalHeader toggle={toggle} className="p-3 bg-primary-subtle">
        <Row className="align-items-center gy-3">
          <div className="col-sm">
            <h5 className="card-title mb-0">Imported products</h5>
          </div>
        </Row>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col lg={12}>
            <Card id="orderList">
              <CardHeader className="border-0"></CardHeader>
              <CardBody className="pt-0">
                <div>
                  {loading ? ( <Loader /> ):
                  (<TableContainer
                    columns={columns}
                    data={rowData || []}
                    isGlobalFilter={false}
                    isAddUserList={false}
                    customPageSize={50}
                    divClass="table-responsive table-card mb-1 mt-2"
                    tableClass="mb-0 align-middle"
                    theadClass="table-light text-dark text-uppercase"
                  />)}
                </div>               
              </CardBody>
            </Card>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default ShowImports;
